import CryptoJS from 'crypto-js';

class CryptoService {
  iv = CryptoJS.enc.Latin1.parse('81436b84f50650ce');
  initialize = async userId => {
    try {
    } catch (err) {
      console.log('error socket', err);
    }
  };
  encrypt = (key, data) => {
    try {
      key = CryptoJS.enc.Latin1.parse(key);
      const enc = CryptoJS.AES.encrypt(data, key, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return enc.ciphertext.toString(CryptoJS.enc.Base64);
    } catch (err) {
      console.log('error encrypt data', err);
    }
  };
  decrypt = (key, data) => {
    try {
      key = CryptoJS.enc.Latin1.parse(key);
      //var ctx = CryptoJS.enc.Base64.parse(data);
      //var enc = CryptoJS.lib.CipherParams.create({ ciphertext: ctx });
      return CryptoJS.AES.decrypt(data, key, { iv: this.iv }).toString(CryptoJS.enc.Utf8);
    } catch (err) {
      console.log('error decrypt data', err);
    }
  };
}

const cryptoService = new CryptoService();
export default cryptoService;
